import { Component } from '@angular/core';

@Component({
  selector: 'page-visitors-reg-disclaimer',
  templateUrl: 'visitors-reg-disclaimer.html'
})
export class VisitorsRegDisclaimerPage {
  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/visitors-reg-disclaimer/visitors-reg-disclaimer.ts